"use client";

import React, { useState } from "react";
import AskQuestionModal from "./AskQuestionModal";

interface AskQuestionButtonProps {
  className?: string;
  buttonText?: string;
}

export default function AskQuestionButton({
  className = "block w-fit text-white text-2sm font-semibold leading-1.3 rounded-2lg bg-primaryBlue px-6 py-3 transition sm:hover:bg-primaryBlue/80 shrink-0 cursor-pointer shadow-xs",
  buttonText = "+ Ask a Question",
}: AskQuestionButtonProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className={className}
      >
        {buttonText}
      </button>
      <AskQuestionModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
